<script>
import options from './StafetLysPoserList.options'
export default options
</script>

<template>
  <article
    class="kb-stafet-flow-light-bags-meta-list kb-optimizely-forms kb-stafet-step"
  >
    <div class="kb-stafet-step__input-wrapper">
      <FormCheckbox
        :modelValue="isLysposerDedicated.toString()"
        v-model="isLysposerDedicated"
        fieldName="isLysposerDedicated"
        :onChangeCallback="(e) => toggleDedicatedLightBag(e.target.checked)"
        :label="labels.isLysposeDedicatedCheckboxLabel"
      />

      <FormCheckbox
        :modelValue="addPersonalNote.toString()"
        v-model="addPersonalNote"
        fieldName="addPersonalNote"
        :onChangeCallback="(e) => toggleAddPersonalNote(e.target.checked)"
        :label="labels.personalNoteCheckboxLabel"
      />
    </div>

    <div v-if="isLysposerDedicated">
      <div class="kb-stafet-step__input-wrapper">
        <h3 class="kb-stafet-step__title">
          {{ labels.personalizeLightBagsTitle }}
        </h3>
        <FormInputDropdown
          fieldName="dedicatedTypeAll"
          :modelValue="dedicatedTypeAll"
          v-model="dedicatedTypeAll"
          :label="labels.dedicationTypeTextLabel"
          :placeholder="labels.dedicationTypePlaceholder"
          :isRequired="true"
          :selectOptions="dedicationTypeOptions"
          v-on:change="setDedicationTypeAll($event.target.value)"
          :isValidationError="dedicatedTypeAll === '' && displayInputError"
          :errorMessageLabel="labels.dedicationTypeErrorMessage"
        />

        <FormInputTextField
          fieldName="lysposeDedicatedToAll"
          :modelValue="lysposeDedicatedToAll"
          v-model="lysposeDedicatedToAll"
          :label="labels.lightDedicatedToTextLabel"
          :isRequired="true"
          v-on:input="setLightDedicatedToAll($event.target.value)"
          :isValidationError="lysposeDedicatedToAll === '' && displayInputError"
          :errorMessageLabel="labels.lightDedicatedToErrorMessage"
          :helpMessageLabel="labels.lightDedicatedToHelpTextLabel"
        />

        <FormInputTextarea
          fieldName="lightPersonalNoteAll"
          :modelValue="lightPersonalNoteAll"
          v-model="lightDedicatedToAll"
          :label="labels.personalNoteTextLabel"
          :maxlength="100"
          :errorMessageLabel="labels.personalNoteErrorMessage"
          :helpMessageLabel="labels.personalNoteHelpTextLabel"
          v-on:input="setPersonalNoteAll($event.target.value)"
        />
      </div>
    </div>
    <template v-else>
      <template v-for="(donation, index) in donationAmountList" :key="index">
        <div class="kb-stafet-step__input-wrapper">
          <h3 class="kb-stafet-step__title">
            {{ labels.personalizeLightBagsTitle }}
            {{ index + 1 }}
          </h3>
          <FormInputDropdown
            fieldName="lysposeDedicatedType"
            :modelValue="donation.lysposeDedicatedType"
            v-model="donation.lysposeDedicatedType"
            :label="labels.dedicationTypeTextLabel"
            :placeholder="labels.dedicationTypePlaceholder"
            :isRequired="true"
            :selectOptions="dedicationTypeOptions"
            v-on:change="updateDedicationType(index, $event.target.value)"
            :isValidationError="
              donation.lysposeDedicatedType === '' && displayInputError
            "
            :errorMessageLabel="labels.dedicationTypeErrorMessage"
          />

          <FormInputTextField
            fieldName="lysposeDedicatedTo"
            :modelValue="donation.lysposeDedicatedTo"
            v-model="donation.lysposeDedicatedTo"
            :label="labels.lightDedicatedToTextLabel"
            :isRequired="true"
            v-on:input="updateLightDedicatedTo(index, $event.target.value)"
            :isValidationError="
              donation.lysposeDedicatedTo === '' && displayInputError
            "
            :errorMessageLabel="labels.lightDedicatedToErrorMessage"
            :helpMessageLabel="labels.lightDedicatedToHelpTextLabel"
          />

          <FormInputTextarea
            fieldName="lightPersonalNote"
            :modelValue="donation.personalNote"
            v-model="donation.personalNote"
            :label="labels.personalNoteTextLabel"
            :maxlength="100"
            :errorMessageLabel="labels.personalNoteErrorMessage"
            :helpMessageLabel="labels.personalNoteHelpTextLabel"
            v-on:input="updatePersonalNote(index, $event.target.value)"
          />
        </div>
      </template>
    </template>
  </article>
</template>
